import _ from "lodash";
import {
  checkStatus,
  parseJSON,
  getApiUrl,
  getHeaderForAjax,
} from "./ServiceHelper";
import { getLoggedInUser } from "./AuthenticationService";
import moment from "moment";
import i18n from "../i18n";

export function getEditSymptomUsers() {
  return {
    data: [
      { label: "User1", value: 1 },
      { label: "User2", value: 2 },
      { label: "User3", value: 3 },
      { label: "User4", value: 4 },
    ],
  };
}
export function getSymptomDetail(_id, type) {
  const userId = getLoggedInUser()._id;
  let url = getApiUrl() + "/symptoms/" + _id;
  if (type != "symptom")
    url = getApiUrl() + "/users/" + userId + "/recipes/" + _id;

  return fetch(url, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON)
    .then((res) => {
      return res;
    });
}
export function getSymptomResponseDetail(_id, type) {
  const userId = getLoggedInUser()._id;
  let url = getApiUrl() + "/users/" + userId + "/response/symptoms/" + _id;
  if (type != "symptom")
    url = getApiUrl() + "/users/" + userId + "/response/meals/" + _id;

  return fetch(url, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON)
    .then((res) => {
      return res;
    });
}

export function searchSymptom(val, type) {
  val = val.toLowerCase();
  const userId = getLoggedInUser()._id;
  let url = getApiUrl() + "/symptoms/keywords/" + val + "/" + userId + "/";
  var category =
    type !== "symptom" && type !== "symptoms" ? "meals" : "symptoms";
  if (category !== "symptoms") {
    url = getApiUrl() + "/users/" + userId + "/recipes/keyword/" + val + "/";
  }
  return fetch(url, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON)
    .then((res) => {
      let data = {
        show: [],
        data: [],
      };
      for (const item of res) {
        if (category == "symptoms") {
          data.data.push({
            _id: item._id,
            name: item.displayname,
            fullname: item.name,
          });
          data.show.push(item.name);
        } else {
          data.data.push({
            _id: item._id,
            name: item.recipe,
            fullname: item.recipe_full,
          });
          data.show.push(item.recipe_full);
        }
      }

      return data;
    })
    .catch(function () {
      let data = {
        show: [],
        data: [],
      };
      return data;
    });
}
export function createSymptom(data, type, callback) {
  const userId = getLoggedInUser()._id;
  let url = getApiUrl() + "/users/" + userId + "/response/symptoms/";
  if (type !== "symptom")
    url = getApiUrl() + "/users/" + userId + "/response/meals/";
  return fetch(url, {
    method: "POST",
    body: JSON.stringify(data),
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON)
    .then((res) => {
      if (callback) callback();
    });
}
export function saveFoodAndSymptoms(data) {
  const userId = getLoggedInUser()._id;
  var AllList = [];
  data.forEach((element) => {
    element.inputs.forEach((item) => {
      var hasFlag = false;
      if (!hasFlag) {
        AllList.push(item);
      }
    });
  });
  var SymptomsList = [];
  var MealsList = [];
  var ActivityList = [];
  var PCPList = [];
  var DrugList = [];
  var SupplementList = [];
  var LocationList = [];
  AllList.forEach((form) => {
    let newData = {};
    form.time = !form.time ? moment() : moment(form.time);
    if (form.category === "01") {
      newData = {
        participants: form.users,
        _id: form.symptom,
        symptom_name: form.name,
        date: form.time.unix() * 1000,
        type: form.type,
        severity: form.scale,
        //label: form.unit || "",
        unitid: form.unit || "142", // Send None if there is no unit
        comment: form.comment || "",
        upc: form.upc,
      };
      SymptomsList.push(newData);
    } else if (form.category === "02") {
      newData = {
        participants: form.users,
        date: form.time.unix() * 1000,
        comment: form.comment || "",
        meals: [
          {
            _id: form.symptom || form._id || "",
            recipe: form.name,
            size: form.scale,
            unitid: form.unit || "",
            upc: form.upc,
          },
        ],
      };
      MealsList.push(newData);
    } else if (form.category === "03") {
      newData = {
        participants: form.users,
        date: form.time.unix() * 1000,
        comment: form.comment || "",
        _id: form.symptom,
        name: form.name,
        value: form.scale,
        unitid: form.unit || "",
      };
      ActivityList.push(newData);
    } else if (form.category === "04") {
      newData = {
        participants: form.users,
        date: form.time.unix() * 1000,
        comment: form.comment || "",
        _id: form.symptom,
        name: form.name,
        value: form.scale,
        unitid: form.unit || "",
        upc: form.upc,
      };
      PCPList.push(newData);
    } else if (form.category === "05") {
      newData = {
        participants: form.users,
        date: form.time.unix() * 1000,
        comment: form.comment || "",
        _id: form.symptom,
        name: form.name,
        value: form.scale,
        unitid: form.unit || "",
        upc: form.upc,
      };
      DrugList.push(newData);
    } else if (form.category === "06") {
      newData = {
        participants: form.users,
        date: form.time.unix() * 1000,
        comment: form.comment || "",
        _id: form.symptom,
        name: form.name,
        value: form.scale,
        unitid: form.unit || "",
        upc: form.upc,
      };
      SupplementList.push(newData);
    } else if (form.category === "07") {
      newData = {
        participants: form.users,
        date: form.time.unix() * 1000,
        comment: form.comment || "",
        _id: form.symptom,
        name: form.name,
        value: form.scale,
        unitid: form.unit || "",
      };
      LocationList.push(newData);
    }
  });
  var result = {
    SymptomsList,
    MealsList,
    ActivityList,
    PCPList,
    DrugList,
    SupplementList,
    LocationList,
  };
  var url = getApiUrl() + "/users/" + userId + "/response/mealsymptom/";
  //var url = getApiUrl() + "/users/" + userId + "/response/inputdata/";

  return fetch(url, {
    method: "POST",
    body: JSON.stringify(result),
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON)
    .catch((e) => {
      return e;
    });
}

export function updateSymptom(data, type, callback) {
  var arr = data,
    brr = [1, 2];

  // Now filter
  var data = arr.filter((f) => brr.includes(f.status));

  const userId = getLoggedInUser()._id;
  let url = getApiUrl() + "/users/" + userId + "/response/all";
  return fetch(url, {
    method: "PUT",
    body: JSON.stringify(data),
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON)
    .then((res) => {
      if (callback) callback();
      return res;
    });
}

export function deleteSymptom(_id, type) {
  const userId = getLoggedInUser()._id;

  let url = getApiUrl() + "/users/" + userId + "/response/symptoms/" + _id;
  if (type !== "symptom")
    url = getApiUrl() + "/users/" + userId + "/response/meals/" + _id;

  return fetch(url, {
    method: "delete",
  })
    .then(checkStatus)
    .then(parseJSON)
    .then((res) => { })
    .catch((e) => {
      return e;
    });
}
export function getReport(val) {
  const userId = getLoggedInUser()._id;
  let start = moment(val.exportStart).unix() * 1000;
  let end = moment(val.exportStart).add(val.end, "days").unix() * 1000;
  let url =
    getApiUrl() +
    "/users/" +
    userId +
    "/report/01?category=" +
    val.category +
    "&start=" +
    start +
    "&end=" +
    end +
    "&participant=" +
    val.user;
  return fetch(url, {
    method: "get",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON)
    .then((res) => { })
    .catch((e) => {
      return e;
    });
}
export function getSymptomList(cond) {
  const userId = getLoggedInUser();
  let start = 0;
  var newEnd = moment(cond.start);
  let end = 0;
  if (typeof (cond.start) == "string") {
    cond.start = moment.utc(cond.start).local();
  }
  if (cond.start) start = cond.start.unix() * 1000;
  if (cond.to) end = newEnd.add(cond.to, "days").unix() * 1000;

  let url = `${getApiUrl()}/users/${userId._id}/response/${cond.category
    }/?start=${start}&end=${end}&participant=${cond.user}`;
  return fetch(url, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON)
    .then((res) => {
      var result = [];
      if (res.meals) {
        result = res.meals.map((item, index) => {
          item.category = "02";
          return item;
        });
      }
      if (res.symptoms) {
        res.symptoms.forEach((item, index) => {
          item.category = "01";
          result.push(item);
        });
      }
      if (res.activity) {
        res.activity.forEach((item, index) => {
          item.category = "03";
          result.push(item);
        });
      }
      if (res.pcps) {
        res.pcps.forEach((item, index) => {
          item.category = "04";
          result.push(item);
        });
      }
      if (res.drugs) {
        res.drugs.forEach((item, index) => {
          item.category = "05";
          result.push(item);
        });
      }
      if (res.supplements) {
        res.supplements.forEach((item, index) => {
          item.category = "06";
          result.push(item);
        });
      }
      if (res.locations) {
        res.locations.forEach((item, index) => {
          item.category = "07";
          result.push(item);
        });
      }
      return result;
    })
    .catch((e) => {
      return [];
    });
}
export async function getCategories() {
  let categories = i18n.t("CATEGORIES", {
    returnObjects: true,
  });
  return categories;
}
/**
 * Fetch full-name suggestions from response endpoints for 1..N participants.
 * - category: "01".."07" as used in your dropdown
 * - participants: array of user IDs (strings)
 * - startMs, endMs: epoch millis; if omitted, defaults to [today-7d 00:00, today 00:00]
 *
 * Returns: { show: string[], data: { fullname, name, category, upc }[] }
 */
export async function fetchRecentHistorySuggestions(category, participants, startMs, endMs) {
  const userId = getLoggedInUser()._id;
  const end   = endMs || moment().endOf("day").valueOf();  // today 11:59:59 PM
  const start = startMs || moment(end).add(-14, "days").valueOf();  // 2 weeks before end

  // build one request per participant, then combine
  const urls = participants.map(p =>
    `${getApiUrl()}/users/${userId}/response/${category}/?start=${start}&end=${end}&participant=${p}`
  );

  const headers = getHeaderForAjax();
  const responses = await Promise.all(
    urls.map(u =>
      fetch(u, { method: "GET", headers })
        .then(checkStatus)
        .then(parseJSON)
        .catch(() => ({}))
    )
  );

  // Returns a stable, canonical id for the item in each category
  const pickCanonicalId = (obj, cat) => {
    if (cat === "02") {
      // Meals: id lives inside the first meal row
      const m = (obj && obj.meals && obj.meals[0]) || {};
      return m._id || m.id || obj._id || obj.id || null;
    }
    if (cat === "01") {
      // Symptoms: prefer the master symptom id if present
      return obj.symptom || obj.symptomId || obj.master_id || obj._id || obj.id || null;
    }
    // Other categories
    const fallbacksByCat = {
      "03": ["act_id", "activityId", "vId", "vid", "item_id", "itemId", "_id", "id"],
      "04": ["pcp_id", "pcpId", "provider_id", "providerId", "item_id", "itemId", "_id", "id"],
      "05": ["drug_id", "drugId", "item_id", "itemId", "_id", "id"],
      "06": ["supplement_id", "supplementId", "item_id", "itemId", "_id", "id"],
      "07": ["location_id", "locationId", "item_id", "itemId", "_id", "id"],
    };
    for (const k of (fallbacksByCat[cat] || ["_id", "id"])) {
      if (obj && obj[k]) return obj[k];
    }
    return null;
  };

  // helper for Mongo's {"$numberLong": "..."} and numeric timestamps
  const toMs = (v) => {
    if (v && typeof v === "object" && typeof v.$numberLong === "string") return Number(v.$numberLong);
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  // Flatten per category
  let items = [];

  for (const root of responses) {
    if (!root || typeof root !== "object") continue;

    if (category === "02") {
      // FOOD: root.meals[] -> each has .date and .meals[]
      const days = Array.isArray(root.meals) ? root.meals : [];
      for (const day of days) {
        const ts = toMs(day && day.date);
        const meals = Array.isArray(day && day.meals) ? day.meals : [];
        for (const m of meals) {
          const _id = pickCanonicalId({ meals: [m] }, "02");
          const fullname = ((m && m.recipe_full) || (m && m.recipe) || (m && m.displayname) || (m && m.symbol) || (m && m.name) || "").trim();
          if (_id && fullname) items.push({ _id: String(_id), fullname, ts });
        }
      }
    } else if (category === "01") {
      // SYMPTOMS: root.symptoms[]
      const arr = Array.isArray(root.symptoms) ? root.symptoms : [];
      for (const s of arr) {
        const _id = pickCanonicalId(s, "01");
        const fullname = ((s && s.symptom_name) || (s && s.fullname) || (s && s.name) || "").trim();
        const ts = toMs(s && s.date) || toMs(s && s.time) || toMs(s && s.createdAt) || toMs(s && s.updatedAt);
        if (_id && fullname) items.push({ _id: String(_id), fullname, ts });
      }
    } else {
      // OTHER CATS: activity(03), pcps(04), drugs(05), supplements(06), locations(07)
      const keyByCat = { "03": "activity", "04": "pcps", "05": "drugs", "06": "supplements", "07": "locations" };
      const key = keyByCat[category];
      const arr = Array.isArray(root && root[key]) ? root[key] : [];
      for (const it of arr) {
        const _id = pickCanonicalId(it, category);
        const fullname = ((it && it.fullname) || (it && it.name) || (it && it.activity_name) || (it && it.location_name) || "").trim();
        const ts = toMs(it && it.date) || toMs(it && it.time) || toMs(it && it.createdAt) || toMs(it && it.updatedAt);
        if (_id && fullname) items.push({ _id: String(_id), fullname, ts });
      }
    }
  }

  // Dedupe by id, keep newest ts
  const byId = new Map();
  for (const it of items) {
    const ex = byId.get(it._id);
    if (!ex || (it.ts || 0) > (ex.ts || 0)) byId.set(it._id, it);
  }
  const data = Array.from(byId.values()).sort((a, b) => (b.ts || 0) - (a.ts || 0));
  const show = data.map(x => x.fullname);

  return { show, data };

}



// WEBPACK FOOTER //
// ./src/services/SymptomService.js